module.exports = __webpack_public_path__ + "img/anli-5.202d1070.jpg";